<ng-container *ngFor="let loc of locations">
    <div class="row fields-group">
        <div class="col d-flex flex-column">
            <div class="row fields-group-header fields-group-header-collapsible flex-shrink-1" *ngIf="usages[loc]?.length" (click)="showUsagesPerLocation[loc] = !showUsagesPerLocation[loc]" [ngClass]="{'expanded': showUsagesPerLocation[loc]}">
                <div class="col justify-content-between d-flex">
                    <label class="input-label mb-0">
                        {{loc | translate}} <span class="badge badge-light ml-2">{{usages[loc]?.length}}</span>
                    </label>
                    <i class="fas ml-auto mt-1" [ngClass]="{'fa-chevron-down': !showUsagesPerLocation[loc], 'fa-chevron-up': showUsagesPerLocation[loc]}" aria-hidden="true"></i>
                </div>
            </div>
            <div *ngIf="usages[loc].length" class="row fields-group-content flex-grow-1">
                <div class="col">
                    <div class="row" *ngFor="let usage of usages[loc]; let i = index">
                        <div class="col">
                            <div class="d-flex item py-2 {{ i === 0 ? 'first' : '' }}">
                                <div class="col d-flex align-items-center">
                                    <span class="w-100 d-flex align-items-center" [innerHTML]="format(usage.name || usage.label || usage.title)"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
